import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "transaction-standalone",
  "use": "transaction-standalone-usage",
  "viewBox": "0 0 11.31 15.54",
  "content": "<symbol viewBox=\"0 0 11.31 15.54\" id=\"transaction-standalone\"><defs></defs><title>Asset 5</title><g id=\"transaction-standalone_Layer_2\" data-name=\"Layer 2\"><g id=\"transaction-standalone_Layer_1-2\" data-name=\"Layer 1\"><path d=\"M11.31,4.41,6.84,0l0,0V0H0V15.54H11.31V4.41Zm-1.84,0H6.81V1.81ZM9.81,14H1.5V1.5H5.31V5.91h4.5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol